const roomOptions = state =>
  state.rooms.map(room => ({
    value: room.id,
    text: room.name,
    room
  }))

export default {
  roomOptions
}
